import { GlobalClassKeys } from 'assets/jss/common-styles';
import MuiContainer from 'components/MuiExtras/MuiContainer';
import { stopAnothersVideoPlayers } from 'components/VideoPlayer';
import YouTube from 'components/Youtube';
import queryString from 'query-string';
import * as React from 'react';
import { RenderVideoType } from 'views/Publication/Components/RenderVideo';
import { YoutubePlayerSearchApi } from 'views/Publication/Components/RenderVideo/RenderVideoCommon';
import { YoutubeSearchBox } from 'views/Publication/Components/RenderVideo/SearchBox';

/////////////////////////////////////////////////////////////////////////////////////////////////////////////

export interface RenderYoutubeState {
    player: any;
}

export class RenderYoutube extends React.PureComponent<RenderVideoType, RenderYoutubeState> {
    private uniqueId: number = new Date().getTime();
    private qs: string = null;

    constructor(props: RenderVideoType) {
        super(props);
        const q = queryString.parse(document.location.search);
        this.qs = q["qs"] ? q["qs"] as string : null;
        this.state = {
            player: null
        };
    }


    render() {
        const { metadata, onEnded, onPlaying, onPause, onProgress, onSeeking, onReady } = this.props;
        const playerId = "yt_" + metadata.uId + "_" + this.uniqueId;
        const outerStyles = { display: "flex", justifyContent: "center" };
        const innerStyles = { height: 360, width: 640 };
        const player = this.state.player == null ? null : new YoutubePlayerSearchApi(this.state.player);

        return (
            <div>
                <MuiContainer>
                    <div style={outerStyles}>
                        <div className={GlobalClassKeys.videoContainer} style={innerStyles}>
                            <YouTube
                                id={playerId}
                                video={metadata.uId}
                                className={GlobalClassKeys.youtubePlayer}
                                autoplay={false}
                                onGetPlayerInstance={(ref) => this.setState({ player: ref })}
                                onPause={(e, api) => { onPause && onPause(api); }}
                                onPlaying={(e, api) => {
                                    stopAnothersYoutubes(playerId);
                                    stopAnothersVideoPlayers(null);
                                    onPlaying && onPlaying(api);
                                }}
                                onProgress={(e, api) => { onProgress && onProgress(api); }}
                                onEnd={(e, api) => { onEnded && onEnded(api); }}
                                onSeeking={(e, api) => { onSeeking && onSeeking(api); }}
                                onCued={(e, api) => { onReady && onReady(api); }}
                            />
                        </div>
                    </div>
                </MuiContainer>

                {
                    player && metadata.hasSubtitles && this.qs &&
                    <YoutubeSearchBox entityId={metadata.publicationId} player={player} querySearch={this.qs} />
                }
            </div>
        );
    }
}


export function stopAnothersYoutubes(currentPlayerId: string) {
    var players = document.getElementsByClassName(GlobalClassKeys.youtubePlayer);

    for (var i = 0; i < players.length; i++) {
        if (players[i].id != currentPlayerId) {
            var fp = new YoutubePlayerSearchApi(players[i].id);
            fp.pause();
        }
    }
}
